export class AuthService {

    static async checkEmailInDb(email) {
        const response = await fetch(process.env.REACT_APP_PUBLIC_PAYMENT_URL + "account/checkEmail?email=" + encodeURIComponent(email));
            if (response.ok) {

                const userId = await response.text();

                localStorage.setItem('userId', userId);
                localStorage.setItem('email', email);
                console.log('userId and email saveed in localstorage', userId, email);
                return true;
            } else {
                return false;
            }
    }
}